export const isLoginPath = (path: string | undefined): boolean => {
    if (path === '/' || path === '/reset-password'){
        return true
    } 
    return false

}